module.exports = __webpack_public_path__ + "prod-assets/door-a668d6.obj";


//////////////////
// WEBPACK FOOTER
// ./assets/door.obj
// module id = 18
// module chunks = 0